import Vue from 'vue';
import { mapGetters } from 'vuex';
import { guid } from '@/mixins/guid';
import linkPage from '@editor/droplets/_bubble-options/components/link-page';

export default Vue.component('edit-button', {
  template: require('./template.html'),
  computed: {
    ...mapGetters(['currentSite', 'viewport', 'currentPage']),
  },
  components: {
    linkPage,
  },
  mixins: [guid],
  name: 'edit-button',
  props: ['droplet', 'show-edit-bubble'],
  data() {
    return {
      hookLimit: 10,
      activeHook: null,
    };
  },
  methods: {
    setText(e, key) {
      this.$store.dispatch('setDropletVal', {
        drp: this.droplet,
        key,
        val: this._getInputVal(e.currentTarget.value),
      });
    },
    addHook() {
      if (!this.droplet.webhooks) {
        this.$store.dispatch('setDropletVal', {
          drp: this.droplet,
          key: 'webhooks',
          val: [],
        });
      }
      if (this.droplet.webhooks.length >= this.hookLimit) {
        return;
      }
      this.$store.dispatch('pushDropletVal', {
        array: this.droplet.webhooks,
        val: {
          _id: this.guid(),
          url: false,
          payload: [],
        },
      });
    },
    updateHook(e, hook) {
      this.$store.dispatch('setDropletVal', {
        drp: hook,
        key: 'url',
        val: this._getInputVal(e.target.value),
      });
    },
    updateKv(params) {
      this.$store.dispatch('setDropletVal', {
        drp: params.item,
        key: params.key,
        val: this._getInputVal(params.$event.target.value),
      });
    },
    addKeyValue() {
      this.$store.dispatch('pushDropletVal', {
        array: this.activeHook.payload,
        val: {
          key: false,
          value: false,
        },
      });
    },
    changeBubbleSize(size) {
      this.$emit('set-bubble-size', size);
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/button/components/_edit-options/index.js